import React from 'react';
import { Popover, IconButton } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
export const InfoPopover = ({ iconSize, title, children, placement = 'bottom', onIconClick, }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? `${placement}-popover` : undefined;
    const Icon = () => (React.createElement(InfoFilled, { size: iconSize, color: "info", "aria-label": "infoIcon" }));
    return (React.createElement("div", { className: "sui-outline-0 sui-inline sui-pt-4" },
        React.createElement(IconButton, { "aria-describedby": id, onClick: handleClick, icon: Icon, size: iconSize, "aria-label": "infoButton" }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: placement, title: title }, children)));
};
